"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullColumnarViewModel = exports.NULL_GL_RESOURCES = void 0;
exports.NULL_GL_RESOURCES = {
    roundedRectRenderer: function () { },
    pickTextureRenderer: function () { },
    attributes: new Map(),
};
exports.nullColumnarViewModel = {
    label: [],
    value: new Float64Array(),
    color: new Float32Array(),
    position0: new Float32Array(),
    position1: new Float32Array(),
    size0: new Float32Array(),
    size1: new Float32Array(),
};
//# sourceMappingURL=types.js.map